import type { FaireProductEntity } from "../../entity_types/product";

export const p_nw7uek3hy4: FaireProductEntity = {
  token: "p_nw7uek3hy4",
  type: "product",
  name: "Squishy Butter Toy 12ct PDQ",
  brandToken: "b_2hkg9shq9f",
  brandName: "ASK",
  imageUrl:
    "https://cdn.faire.com/fastly/16e2253445fec140683e730394b2da56232c80f850a514b748bfa61f2e747973.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cc93891663b74ee09b2a7489372cf0a08cfd3418fa9d5e2a9575a125b139586e.jpeg",
    "https://cdn.faire.com/fastly/7e90b08529133c90063800a46b39e14d77fb1c53cb2b40737ea4f281b3a937e3.jpeg",
    "https://cdn.faire.com/fastly/5f0f201c5a2d95de2ebf0019e457fbbae621f2609a1f0ac2bbe32474b48e22b4.jpeg",
  ],
  priceDollars: 5,
  description:
    "Turn everyday stress into satisfying fun with this ultra-soft Butter Squishy Toy! Designed to look just like a stick of butter, this soft and slow-rising squishy delivers a calming, tactile experience that’s perfect for kids and adults alike.\n\nSqueeze it, stretch it, and watch it slowly rise back to shape—providing a soothing sensory effect that helps reduce stress, anxiety, and boredom.\n\nPerfect for retail displays, impulse buys, party favors, and desk toys!\n\n✨ Key Features\n-Super Soft & Slow Rising – Extra satisfying squeeze with a slow rebound effect\n-Realistic Butter Design – Looks like real butter (but clearly labeled NOT REAL FOOD)\n-Stress Relief & Sensory Play – Great for anxiety, focus, and fidgeting\n-Durable & Reusable – Made for repeated squeezing without losing shape\n-Individually Wrapped – Clean and ready for retail sale\n-Great for All Ages (3+)",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:34.905Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
